module.exports = __webpack_public_path__ + "static/media/home.4a865c67.png";